import appData from '../app-data/app-data';
import performance from '../performance/performance';

export const CODE_PARSING_PHASE_NAME = 'codeParsingPhase';

export default class LoadingPhases {
  constructor(appName) {
    this.appName = appName;
    this.phases = new Map();
  }

  getAppLoadingPhaseData(phaseName) {
    if (phaseName) {
      return this.phases.get(phaseName);
    }
  }

  saveAppLoadingPhase({ name }) {
    this._createCodeParsingPhaseIfNotExist();

    if (!this.phases.has(name)) {
      this.phases.set(name, {
        name,
        phaseStartTime: performance.now(),
        index: this.phases.size,
      });
    }
  }

  getNextPhaseToReport() {
    this._createCodeParsingPhaseIfNotExist();
    let latestStep = CODE_PARSING_PHASE_NAME;

    this.phases.forEach((phase, name) => {
      if (phase.index > this.phases.get(latestStep).index) {
        latestStep = name;
      }
    });

    return this.phases.get(latestStep);
  }

  getPhasePreviousTo(name) {
    const currentPhase = this.phases.get(name);
    let previousPhase = undefined;

    this.phases.forEach(phase => {
      if (phase.index === currentPhase.index - 1) {
        previousPhase = phase;
      }
    });

    return previousPhase;
  }

  _createCodeParsingPhaseIfNotExist() {
    if (!this.phases.has(CODE_PARSING_PHASE_NAME)) {
      this.phases.set(CODE_PARSING_PHASE_NAME, {
        phaseStartTime: appData.getStartLoadTime(this.appName),
        index: 0,
        name: CODE_PARSING_PHASE_NAME,
      });
    }
  }
}
